import Vue from 'vue';
import { VueSpinners } from '@saeris/vue-spinners';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './routers/main-router';
import { mixins } from './mixins/mixins';
import { ServiceBus } from './services/service-bus';

import './assets/vendors/custom/fullcalendar/fullcalendar.bundle.css';
import './assets/vendors/global/vendors.bundle.css';
import './assets/css/admin/style.bundle.css';
import './assets/css/admin/skins/header/base/light.css';
import './assets/css/admin/skins/header/menu/light.css';
import './assets/css/admin/skins/brand/navy.css';
import './assets/css/admin/skins/aside/navy.css';

import './assets/vendors/global/vendors.bundle';
import './assets/js/admin/scripts.bundle';
import './assets/vendors/custom/fullcalendar/fullcalendar.bundle';
import './assets/js/admin/pages/dashboard';

Vue.use(VueSpinners);
Vue.use(Vuelidate);
Vue.config.productionTip = false;
Vue.prototype.$serviceBus = ServiceBus;

new Vue({
  mixins: [mixins],
  router,
  render: h => h(App)
}).$mount('#app');

window.$stringify = obj => {
  let str = '';
  Object.entries(obj).forEach(elem => {
    str += elem.key + ': ' + elem.value + '\n';
  });
  return str;
};

window.jsonToQueryString = json =>
  // eslint-disable-next-line implicit-arrow-linebreak
  Object.keys(json)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(json[key]))
    .join('&');
